import React, { useMemo, useState } from 'react';
import Slider from 'react-slick';

import slideAlex from '../../../main/assets/images/fpvonepilot/alex-slide.webp';
import slideAlexTablet from '../../../main/assets/images/fpvonepilot/alex-slide-tablet.webp';
import slideAlexTabletVert from '../../../main/assets/images/fpvonepilot/alex-slide-tablet-vert.webp';
import slideAlexMobile from '../../../main/assets/images/fpvonepilot/alex-slide-mobile.webp';
import slideShames from '../../../main/assets/images/fpvonepilot/shames-slide.webp';
import slideShamesTablet from '../../../main/assets/images/fpvonepilot/shames-slide-tablet.webp';
import slideShamesTabletVert from '../../../main/assets/images/fpvonepilot/shames-slide-tablet-vert.webp';
import slideShamesMobile from '../../../main/assets/images/fpvonepilot/shames-slide-mobile.webp';
import slideNiel from '../../../main/assets/images/fpvonepilot/niel-slide.webp';
import slideNielTablet from '../../../main/assets/images/fpvonepilot/niel-slide-tablet.webp';
import slideNielTabletVert from '../../../main/assets/images/fpvonepilot/niel-slide-tablet-vert.webp';
import slideNielMobile from '../../../main/assets/images/fpvonepilot/niel-slide-mobile.webp';
import slideMin from '../../../main/assets/images/fpvonepilot/min-slide.webp';
import slideMinTablet from '../../../main/assets/images/fpvonepilot/min-slide-tablet.webp';
import slideMinTabletVert from '../../../main/assets/images/fpvonepilot/min-slide-tablet-vert.webp';
import slideMinMobile from '../../../main/assets/images/fpvonepilot/min-slide-mobile.webp';
import slidEevan from '../../../main/assets/images/fpvonepilot/evan-slide.webp';
import slidEevanTablet from '../../../main/assets/images/fpvonepilot/evan-slide-tablet.webp';
import slidEevanTabletVert from '../../../main/assets/images/fpvonepilot/evan-slide-tablet-vert.webp';
import slidEevanMobile from '../../../main/assets/images/fpvonepilot/evan-slide-mobile.webp';
import slideMai from '../../../main/assets/images/fpvonepilot/mai-slide.webp';
import slideMaiTablet from '../../../main/assets/images/fpvonepilot/mai-slide-tablet.webp';
import slideMaiTabletVert from '../../../main/assets/images/fpvonepilot/mai-slide-tablet-vert.webp';
import slideMaiMobile from '../../../main/assets/images/fpvonepilot/mai-slide-mobile.webp';
import profileAlex from '../../../main/assets/images/fpvonerace/alex-campbell.webp';
import profileNiel from '../../../main/assets/images/fpvonerace/niel-marek.webp';
import profileShames from '../../../main/assets/images/fpvonerace/shawn-ames.webp';
import profileMin from '../../../main/assets/images/fpvonepilot/min-chan-kim.webp';
import profileEvan from '../../../main/assets/images/fpvonerace/evan-turner.webp';
import profileMai from '../../../main/assets/images/fpvonepilot/mai-shiro.webp';

export const PilotsSlider = ({ windowWidth }: { windowWidth: number }) => {
  const [isAutoplayActive, setIsAutoplayActive] = useState(true);
  const [isDragging, setIsDragging] = useState(false);

  const isSmallLaptop = useMemo(
    () => windowWidth > 1200 && windowWidth <= 1600,
    [windowWidth],
  );

  const isTablet = useMemo(() => windowWidth > 1200 && windowWidth <= 1600, [
    windowWidth,
  ]);

  const isTabletVertical = useMemo(
    () => windowWidth >= 501 && windowWidth <= 991,
    [windowWidth],
  );

  const isMobile = useMemo(() => windowWidth <= 500, [windowWidth]);

  // Format titles with line breaks
  const formatTitle = (title: string, id: number) => {
    switch (id) {
      case 1: // Alex
        return (
          <>
            <span>The best for</span>
            <br />
            <span>the best!</span>
          </>
        );
      case 3: // Niel
        return (
          <>
            <span>Beautiful,</span>
            <br />
            <span>inside and out</span>
          </>
        );
      case 6: // Mai
        return (
          <>
            <span>Settle for</span>
            <br />
            <span>nothing less</span>
          </>
        );
      default:
        return title;
    }
  };

  const getImage = (slide: {
    id?: number;
    imageUrl: any;
    imageUrlTablet: any;
    imageUrlTabletVert: any;
    imageUrlMobile: any;
    profileUrl?: string;
    title?: string;
    formattedTitle?: any;
    description?: string;
    username?: string;
    name?: string;
    align?: string;
  }) => {
    if (isMobile) return slide.imageUrlMobile || slide.imageUrl;
    if (isTabletVertical)
      return slide.imageUrlTabletVert || slide.imageUrlTablet || slide.imageUrl;
    if (isTablet) return slide.imageUrlTablet || slide.imageUrl;
    return slide.imageUrl;
  };

  const slides = useMemo(
    () => [
      {
        id: 1,
        imageUrl: slideAlex,
        imageUrlTablet: slideAlexTablet,
        imageUrlTabletVert: slideAlexTabletVert,
        imageUrlMobile: slideAlexMobile,
        profileUrl: profileAlex,
        imageAlt:
          'Alex Campbell, a pilot giving a testimonial about the headset.',
        profileAlt: "Alex Campbell's profile picture.",
        title: 'The best for the best!',
        formattedTitle: formatTitle('The best for the best!', 1),
        description:
          '“When it comes to racing, there’s no point in me using anything but the best. That’s why you only see me using ORQA goggles.”',
        username: 'AlexFPV',
        name: 'Alex Campbell',
        align: 'right',
      },
      {
        id: 2,
        imageUrl: slideShames,
        imageUrlTablet: slideShamesTablet,
        imageUrlTabletVert: slideShamesTabletVert,
        imageUrlMobile: slideShamesMobile,
        imageAlt:
          'Shawn Ames, a pilot giving a testimonial about the equipment.',
        profileAlt: "Shawn Ames's profile picture.",
        profileUrl: profileShames,
        title: 'A perfect combo!',
        formattedTitle: 'A perfect combo!',
        description:
          '“Orqa goggles are the perfect combination of quality and innovation. They understand what we need and simply deliver.”',
        username: 'ShamesFPV',
        name: 'Shawn Ames',
        align: 'left',
      },
      {
        id: 3,
        imageUrl: slideNiel,
        imageUrlTablet: slideNielTablet,
        imageUrlTabletVert: slideNielTabletVert,
        imageUrlMobile: slideNielMobile,
        profileUrl: profileNiel,
        imageAlt: 'Niel Marek, a pilot giving a testimonial.',
        profileAlt: "Niel Marek's profile picture.",
        title: 'Beautiful, inside and out',
        formattedTitle: formatTitle('Beautiful, inside and out', 3),
        description:
          '“These goggles are so nice. From the displays in the inside to the fit and finish of the shell, they look amazing. The super smooth 60 fps DVR and the FPV connect module make these goggles a top-shelf option for any pilot looking to run the best possible gear."',
        username: 'Niel Marek',
        name: 'FPV Pilot',
        align: 'right',
      },
      {
        id: 4,
        imageUrl: slideMin,
        imageUrlTablet: slideMinTablet,
        imageUrlTabletVert: slideMinTabletVert,
        imageUrlMobile: slideMinMobile,
        imageAlt: 'MinChan Kim, a pilot giving a testimonial about the device.',
        profileAlt: "MinChan Kim's profile picture.",
        profileUrl: profileMin,
        title: 'Do more, see better, and perform at your highest',
        formattedTitle: 'Do more, see better, and perform at your highest',
        description:
          '"When I put my goggles on that means the game has officially begun. All I truly care about is the overall performance of my gear and how comfortable it is to use. With that in mind, the new Orqas are, without a doubt, the way to go."',
        username: 'MCKFPV',
        name: 'MinChan Kim',
        align: 'left',
      },
      {
        id: 5,
        imageUrl: slidEevan,
        imageUrlTablet: slidEevanTablet,
        imageUrlTabletVert: slidEevanTabletVert,
        imageUrlMobile: slidEevanMobile,
        profileUrl: profileEvan,
        imageAlt: 'Evan Turner, a pilot giving a testimonial.',
        profileAlt: "Evan Turner's profile picture.",
        title: 'A tried and true performance goggle',
        formattedTitle: 'A tried and true performance goggle',
        description:
          "“It is not made for a large pleasant viewing experience, but instead provides the amenities needed to perform when it counts. Racing, freestyle, it doesn't matter, if you are able to see the entire image at once without having to move or refocus your eyes I truly believe you have the ability to perform better. Additionally, it's imperative for this image to be crisp. When scaling down an image on a larger fov goggle you lose a significant amount of pixel density, the only way to fix this is to bring a full resolution race field of view goggle to market. Which is what we did. Combine that with the 485 dollar price point and you will not find a better bang for your buck goggle on the market.”",
        username: 'HeadsupFPV',
        name: 'Evan Turner',
        align: 'right',
      },
      {
        id: 6,
        imageUrl: slideMai,
        imageUrlTablet: slideMaiTablet,
        imageUrlTabletVert: slideMaiTabletVert,
        imageUrlMobile: slideMaiMobile,
        profileUrl: profileMai,
        imageAlt:
          'Mai Shiro, a pilot giving a testimonial about the viewing equipment.',
        profileAlt: "Mai Shiro's profile picture.",
        title: 'Settle for nothing less',
        formattedTitle: formatTitle('Settle for nothing less', 6),
        description:
          "“Absolutely in love with the Orqa goggles! The view is very clean all the time and the UI is quite pleasant to the eye. Most importantly, it's easy to check and send my DVR to my phone, which is very helpful when sharing my flight experience with the FPV community.”",
        username: 'NAMAIIKIFPV',
        name: 'Mai Shiro',
        align: 'left',
      },
    ],
    [],
  );

  const settings = useMemo(
    () => ({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: isAutoplayActive,
      autoplaySpeed: 6000,
      pauseOnHover: false,
      onSwipe: () => {
        setIsDragging(true);
      },
      afterChange: () => {
        if (isDragging && isAutoplayActive) {
          setIsAutoplayActive(false);
        }
        setIsDragging(false);
      },
    }),
    [isAutoplayActive, isDragging],
  );

  return (
    <div className="fpv-pilot-slider-section">
      <Slider {...settings} className="fpv-pilot-slider">
        {slides.map(slide => (
          <div key={slide.id}>
            <div
              className={`fpv-pilot-slider-content ${
                isTabletVertical || isMobile ? 'mobile-layout' : ''
              }`}
            >
              <img
                className="fpv-pilot-slider-image"
                style={{
                  objectPosition:
                    windowWidth <= 991 && windowWidth > 1200
                      ? 'center 0%'
                      : slide.id > 2
                      ? slide.align === 'left'
                        ? '80% 0%' // 80% from left, 10% from top
                        : slide.id === 5
                        ? '40% 0%'
                        : '30% 0%'
                      : 'center 0%',
                }}
                src={getImage(slide)}
                alt={slide.imageAlt}
              />
              <div
                className={`fpv-pilot-slider-text ${
                  isTabletVertical || isMobile ? 'mobile-position' : ''
                }`}
                style={{
                  [slide.align]:
                    windowWidth > 2700
                      ? `${137 + (windowWidth - 2700) / 2}px`
                      : isMobile || isTabletVertical
                      ? 'unset'
                      : isTablet
                      ? '80px'
                      : isSmallLaptop
                      ? '100px'
                      : '137px',
                }}
              >
                <h2 className="fpv-pilot-slider-title">
                  {slide.formattedTitle}
                </h2>
                <p className="fpv-pilot-slider-description">
                  {slide.description}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="2"
                  viewBox="0 0 100 2"
                  preserveAspectRatio="none"
                  className="fpv-pilot-slider-line"
                >
                  <path
                    d="M0 0.930664H710"
                    stroke="url(#paint0_linear_4995_1107)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_4995_1107"
                      x1="0"
                      y1="1.43066"
                      x2="710"
                      y2="1.43066"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.711538" stopColor="#EE2737" />
                      <stop offset="1" stopColor="#EE2737" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
                <div className="fpv-pilot-slider-user">
                  <img
                    src={slide.profileUrl}
                    alt={slide.profileAlt}
                    className="fpv-pilot-slider-user-image"
                  />
                  <div className="fpv-pilot-slider-user-text">
                    <h3 className="fpv-pilot-slider-user-title">
                      {slide.username}
                    </h3>
                    <p className="fpv-pilot-slider-user-description">
                      {slide.name}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
